import { ArrowRight, TrendingUp } from "lucide-react";
import { BRAND_LIGHT, ButtonLink, INK, Reveal, WRAP } from "./ui";

/* "Get started" call-to-action band, shown above the IZSales in Action section. */
export default function GetStartedBanner() {
  return (
    <section aria-label="Get started with IZSales" style={{ background: INK }}>
      <div className={`${WRAP} flex flex-col gap-8 py-12 md:flex-row md:items-center md:justify-between`}>
        <Reveal className="flex-1">
          <div className="flex items-start gap-5">
            <TrendingUp
              size={56}
              strokeWidth={2.25}
              className="flex-shrink-0 hidden sm:block"
              style={{ color: BRAND_LIGHT }}
              aria-hidden="true"
            />
            <div>
              <h2 className="text-[28px] font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl">
                Getting started with IZSales is easy.
                <span className="block" style={{ color: BRAND_LIGHT }}>
                  Choose your plan.
                </span>
              </h2>
              <p className="max-w-2xl mt-4 text-[16px] leading-relaxed text-slate-300">
                Compare our plans, pick the one that fits your team, and bring your companies, pipeline, tasks and
                conversations together in one place.
              </p>
            </div>
          </div>
        </Reveal>
        <ButtonLink to="/pricing" variant="light" className="flex-shrink-0 !h-14 !px-9 !text-[16px]">
          View pricing <ArrowRight size={18} />
        </ButtonLink>
      </div>
    </section>
  );
}